import mutations from './mutations';

const state = () => ({
  snack: '',
});

export default {
  namespaced: true,
  state,
  mutations,
};
